import { Klass } from "./core";

const csl = Klass.new_("Console");
export default csl;
export { Klass };
